import React from 'react';
import './AttachmentItem.css';
import collegeConfig from '../../config/collegeConfig';
import { Capacitor } from '@capacitor/core';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { FileOpener } from '@capacitor-community/file-opener';
import { FaImage, FaFilePdf, FaSpinner, FaTimes } from 'react-icons/fa';

// Shared attachment preview/open widget — used by ViewLogbooks.js and EntryDetailsModal.js.
// Handles both web preview (image/PDF iframe) and native Capacitor file-open for PDFs.
const AttachmentItem = ({ attachment }) => {
  const [loading, setLoading] = React.useState(false);
  const [viewerOpen, setViewerOpen] = React.useState(false);
  const [viewerUrl, setViewerUrl] = React.useState('');

  const handleOpen = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(
        `${collegeConfig.api.baseURL}/upload/signed-url?key=${encodeURIComponent(attachment.key)}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (!res.ok) { setLoading(false); return; }
      const data = await res.json();

      if (Capacitor.isNativePlatform() && attachment.type !== 'image') {
        const fileRes = await fetch(data.url);
        const blob = await fileRes.blob();
        const reader = new FileReader();
        reader.onloadend = async () => {
          const base64 = reader.result.split(',')[1];
          const fileName = attachment.name || 'attachment.pdf';
          const result = await Filesystem.writeFile({
            path: fileName,
            data: base64,
            directory: Directory.Cache,
            recursive: true
          });
          try {
            await FileOpener.open({ filePath: result.uri, contentType: 'application/pdf' });
          } catch {
            alert(`File saved. Open from Files app: ${fileName}`);
          }
          setLoading(false);
        };
        reader.readAsDataURL(blob);
        return;
      }

      setViewerUrl(data.url);
      setViewerOpen(true);
    } catch { /* ignore */ }
    setLoading(false);
  };

  return (
    <>
      <div className="attachment-item">
        <div className="attachment-icon">
          {attachment.type === 'image' ? <FaImage /> : <FaFilePdf />}
        </div>
        <span className="attachment-name">{attachment.name}</span>
        <button className="btn-view-attachment" onClick={handleOpen} disabled={loading}>
          {loading ? <FaSpinner className="spin" /> : 'View'}
        </button>
      </div>
      {viewerOpen && (
        <div className="attachment-viewer-overlay" onClick={() => setViewerOpen(false)}>
          <div className="attachment-viewer-content" onClick={e => e.stopPropagation()}>
            <div className="attachment-viewer-header">
              <span className="attachment-viewer-name">{attachment.name}</span>
              <button className="attachment-viewer-close" onClick={() => setViewerOpen(false)}>
                <FaTimes />
              </button>
            </div>
            {attachment.type === 'image'
              ? <img src={viewerUrl} alt={attachment.name} className="attachment-viewer-img" />
              : <iframe src={viewerUrl} title={attachment.name} className="attachment-viewer-iframe" />
            }
          </div>
        </div>
      )}
    </>
  );
};

export default AttachmentItem;
